<span *ngFor="let email of userEmails">
    <app-user-chip [userEmail]="email"></app-user-chip>
</span>